// A lightweight, read-only counterpart to PurchaseSheet — reuses the
// same BottomSheet shell, just for informational content (Settings
// rows) instead of a checkout flow. No CTA button needed; the shell's
// close button and drag-to-dismiss are enough to leave.

import type { ReactNode } from 'react';
import { BottomSheet } from '@/components/BottomSheet';
import type { UseBottomSheetResult } from '@/hooks/useBottomSheet';
import styles from './InfoSheet.module.scss';

export interface InfoSheetProps {
  bottomSheet: UseBottomSheetResult;
  title: string;
  children: ReactNode;
}

export function InfoSheet({ bottomSheet, title, children }: InfoSheetProps) {
  return (
    <BottomSheet bottomSheet={bottomSheet}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.body}>{children}</div>
    </BottomSheet>
  );
}
